import { useQueryClient } from '@tanstack/react-query';

import { api, CARE_PLAN_ACTIVITY_NOTE_TITLE } from '@/api';
import { useFctReport } from '@/shared/hook';

export const useCreateBreakTheGlassNote = () => {
  const { report } = useFctReport();
  const queryClient = useQueryClient();
  const createBreakTheGlassNoteMutation =
    api.fct.carePlanNotes.mutation.useCreateCarePlanActivityNote(queryClient);

  const handleCreateBreakTheGlassNote = (content: string) => {
    if (!report?.careActivityId) {
      return;
    }

    if (createBreakTheGlassNoteMutation.isPending) {
      return;
    }

    createBreakTheGlassNoteMutation.mutate({
      payload: {
        activity_id: report.careActivityId,
        body: {
          content,
          title: CARE_PLAN_ACTIVITY_NOTE_TITLE.CRITICAL_RESULTS_NOTIFICATION,
        },
      },
    });
  };

  return {
    isCreatingBreakTheGlassNote: createBreakTheGlassNoteMutation.isPending,
    onCreateBreakTheGlassNote: handleCreateBreakTheGlassNote,
  };
};
